import React from 'react';
export function OpeningHook() {
  return <section className="bg-dark-surface text-white py-20 px-4 md:px-8" data-id="element-108">
      <div className="max-w-3xl mx-auto" data-id="element-109">
        <h2 className="font-oswald text-3xl md:text-5xl font-bold mb-8 text-center text-brand-orange uppercase" data-id="element-110">
          Mirate honesto un segundo.
        </h2>
        <div className="font-inter text-lg md:text-xl text-gray-300 space-y-6 leading-relaxed" data-id="element-111">
          <p data-id="element-112">
            Eliminaste el azúcar. Redujiste el vino. Saliste a correr dos veces
            por semana. Te dolieron las rodillas, llegaste destruido a casa, y
            la panza... igual.
          </p>
          <p data-id="element-113">
            No es que seas flojo. No es que te falte disciplina. Es que estás
            usando herramientas equivocadas para un problema que no entendiste
            bien todavía.
          </p>
          <p data-id="element-114">
            El cardio sostenido dispara el cortisol. El cortisol le manda una
            señal directa a tu grasa abdominal para que no se mueva. Estás
            trabajando duro contra tu propia biología sin saberlo.
          </p>
          <p className="text-white font-semibold text-xl md:text-2xl border-l-4 border-brand-orange pl-6 my-8" data-id="element-115">
            "¿Cuándo me pasó esto?"
          </p>
        </div>
      </div>
    </section>;
}